import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=bac3ded4&"
import script from "./VButton.vue?vue&type=script&lang=ts&"
export * from "./VButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports